import { render, staticRenderFns } from "./ProgramLevel.vue?vue&type=template&id=7fda7bde&"
import script from "./ProgramLevel.vue?vue&type=script&lang=ts&"
export * from "./ProgramLevel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports